var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#5298FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32 19C35.1627 19 38.217 20.153 40.5907 22.243C42.9645 24.333 44.4949 27.2167 44.8953 30.354C45.2958 33.4912 44.5388 36.6669 42.7662 39.2862C40.9935 41.9055 38.3268 43.7887 35.2655 44.5832C32.2042 45.3776 28.9583 45.0288 26.1356 43.6021C23.313 42.1754 21.1073 39.7686 19.9316 36.8325C18.7559 33.8964 18.6909 30.6324 19.7487 27.6518C20.8066 24.6713 22.9147 22.1786 25.6783 20.6406",
    stroke: "#5298FF",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 32C45 35.1627 43.847 38.217 41.757 40.5907C39.667 42.9645 36.7833 44.4949 33.646 44.8953C30.5088 45.2958 27.3331 44.5388 24.7138 42.7662C22.0945 40.9935 20.2113 38.3268 19.4168 35.2655C18.6224 32.2042 18.9712 28.9583 20.3979 26.1356C21.8246 23.313 24.2314 21.1073 27.1675 19.9316C30.1036 18.7559 33.3676 18.6909 36.3482 19.7487",
    stroke: "#5298FF",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIndicator);
export default __webpack_public_path__ + "static/media/LoadingIndicator.4d16a896b80b3dbf0ca3be9610023fc1.svg";
export { ForwardRef as ReactComponent };